import React from "react";
import {
    CircularProgress,
    InputAdornment,
    MenuItem,
    TextField,
} from "@mui/material";
import { FieldRenderProps } from "react-final-form";

type Props = {
    label: string;
    options: SelectOption[];
    required?: boolean;
    placeholder?: string;
};

export type SelectOption = {
    label: string;
    value: string;
    isDefault?: boolean;
    disabled?: boolean

};

export type SelectProps = FieldRenderProps<Props>;

export const getDefaultValue = (options: SelectOption[]): string =>
    options?.find(x => x.isDefault)?.value ?? '';

const SelectField: React.FC<SelectProps> = ({ input, meta, loading, options, helperText, ...rest }: SelectProps) => {
    const { invalid, touched, error, submitError } = meta;
    const hasError = invalid && touched;
    return (
        <TextField {...rest} {...input}
            helperText={hasError ? submitError || error : helperText}
            value={loading ? "" : input.value ?? meta.initial ?? ""}
            error={hasError}
            // disabled={input.disabled || loading}
            fullWidth
            select
            slotProps={{
                inputLabel: { shrink: true },
                input: {
                    notched: false, endAdornment: loading ? (
                        <InputAdornment position="end" sx={{ pr: 2 }}>
                            <CircularProgress size={24} />
                        </InputAdornment>
                    ) : undefined,
                },
                select: { displayEmpty: true, MenuProps: { slotProps: { paper: { sx: { maxHeight: "300px", overflowY: "auto" } } } } }

            }
            }
        >
            <MenuItem value="" disabled>
                <em>{rest.placeholder ?? rest.label}</em>
            </MenuItem>
            {
                (options?.map((option: SelectOption) => (
                    <MenuItem key={option.value} value={option.value} disabled={option.disabled}>
                        {option.label}
                    </MenuItem>
                ))
                )
            }
        </TextField>
    )
}

SelectField.displayName = "SelectField";

export default SelectField;
